export const SET_PRIMARY_PHONE_START = 'SET_PRIMARY_PHONE_START';
export const SET_PRIMARY_PHONE_SUCCESS = 'SET_PRIMARY_PHONE_SUCCESS';
export const SET_PRIMARY_PHONE_ERROR = 'SET_PRIMARY_PHONE_ERROR';
export const SET_PRIMARY_PHONE_END = 'SET_PRIMARY_PHONE_END';
export const SET_PRIMARY_PHONE_CLEAR = 'SET_PRIMARY_PHONE_CLEAR';
